const Route = require('common/route');
const i18n = require('i18next');
const Backbone = require('backbone');
const Moment = require('moment');
const Marked = require('balus/util/marked');

const getResourceUrl = function(kind, data, parentResources, eventType) {
    let url = null;

    switch(kind) {
        case 'Group':
            url = Route.urlFor('path:group', {
                gid: data['id']
            });
            break;
        case 'Project':
            url = Route.urlFor('path:project', {
                pid: data['id']
            });
            break;
        case 'Task':
            url = Route.urlFor('path:project', {
                pid: data['project_id']
            });
            break;
        case 'Action':
            url = Route.urlFor('path:action', {
                pid: _.find(parentResources, r => {
                    return r.kind == 'Project'
                }).id,
                id: data['id']
            });
            break;
        case 'DataSet':
            url = Route.urlFor('path:diagram', {
                pid: data['project_id'],
                did: data['diagram_id']
            });
            break;
        case 'DataSetSnapshot':
            url = Route.urlFor('path:diagram', {
                pid: data['project_id'],
                did: data['diagram_id']
            }, {
                dt: data['created_at']
            });
            break;
        case 'Comment':
            if(
                eventType == 'action_comment_created' ||
                eventType == 'action:content:added' ||
                 eventType == 'action:content:updated'
            ) {
                url = Route.urlFor('path:action:comment', {
                    pid: data['project_id'],
                    aid: data['action_id'],
                    comment_id: data['id']
                });
            } else {
                url = Route.urlFor('path:comment', {
                    pid: data['project_id'],
                    did: data['diagram_id'],
                    comment_id: data['id']
                });
            }
            break;
        case 'UserRequest':
            url = Route.urlFor('path:feedback', {
                rid: data['id']
            });
            break;
        case 'UserRequestComment':
            url = Route.urlFor('path:feedback', {
                rid: _.find(parentResources, r => {
                    return r.kind == 'UserRequest'
                }).id
            });
            break;
        default:
        // nothing to do ...
    }

    return url;
};
/**
 * @exports models/notification-model
 * {
 *   id: 5150590346723328,
 *   event_at: "2016-03-30T03:30:06Z",
 *   event_type: "comment_created",
 *   link: null,
 *   message: [
 *     {event_subtype: "body_created"},
 *     {body: "..."}
 *     ],
 *   message_type: "review",
 *   parent_resources: [
 *     {
 *       kind: "Group",
 *       urlsafe: "...",
 *       data: {
 *         name: "hoge"
 *       }
 *     },
 *     ...
 *   ],
 *   read: false,
 *   resource: {
 *     deleted: null,
 *     kind: "Comment",
 *     id: 1234,
 *     data: {
 *     }
 *   },
 *   sender: {}
 */
module.exports = new Backbone.Model.extend({
    /**
     * Backbone.Model を extend した NotificationModel を定義する
     */
    initialize: function() {
        _.bindAll(this, 'resourceIds', 'content');
        this._resourceIds = null;
    },

    idParams: function() {
        const params = {
            notification_id: this.get('id')
        };
        return params;
    },

    isRead: function() {
        return this.get('read');
    },

    url: function() {
        const key = this.isNew() ? 'api:notifications' : 'api:notification';
        return Route.urlFor(key, this.idParams());
    },

    resourceIds: function() {
        if(!this._resourceIds) {
            this._resourceIds = _.flatten([
                _.map(this.get('parent_resources'), function(e) {
                    return e['kind'].toLowerCase() + ':'
                        + e['data']['id'];
                }),
                'user:' + this.get('sender')['id']
            ]);
        }
        return this._resourceIds;
    },

    content: function() {
        let c = [];
        // ParentResources
        c.push(_.map(this.get('parent_resources'), function(e) {
            return [e['data']['id'], e['data']['name'], e['data']['description']];
        }));
        // message
        c.push(_.map(this.get('message'), function(msg) {
            return [msg['before'], msg['after']];
        }));
        // sender
        c.push([this.get('sender')['id'], this.get('sender')['name']]);

        c = _.flatten(c);
        const str = _.reduce(c, function(memo, s){ return memo + ' ' + s; }, '');
        return str.toLowerCase();
    },

    isContainWords: function(words) {
        const content = this.content();
        const hasWord = function(word) {
            return content.indexOf(word) != -1;
        };
        if(words.length > 0 && !_.every(words, hasWord)) {
            return false;
        }
        return true;
    },

    isContainResources: function(resourceIds) {
        const ids = this.resourceIds();
        if(resourceIds.length > 0 &&
            _.intersection(resourceIds, ids).length !=
                resourceIds.length) {
            return false;
        }
        return true;
    },

    /**
     * type は Resource Type の String
     * e.g.) Group, Project
     */
    getResourceByType: function(type) {
        let r = this.get('resource');
        if(r.kind == type) {
            return r.data;
        }
        r = _.find(this.get('parent_resources'), function(r) {
            return r.kind == type;
        });
        if(r) {
            return r.data;
        }
        return null;
    },

    /**
     * @returns {{url: string, target: string}}
     */
    getLinkURL: function() {
        const r = this.get('resource');
        if(this.get('event_type') == 'element_updated') {
            return null;
        }

        return getResourceUrl(r.kind, r.data, this.get('parent_resources'), this.get('type'));
    },

    getCreatedAt: function() {
        return Moment(this.get('created_at'));
    },

    getEventAt: function() {
        return Moment(this.get('event_at'));
    },

    getImageURL: function() {
        const r = this.get('resource');
        const p = this.get('parent_resources');
        const sender = this.get('sender');

        if(r.kind == 'DataSet' || r.kind == 'Task' || r.kind == 'Action') {
            return _.find(p, function(r){
                return r.kind == 'Project';
            }).data.image_url;
        }
        else if(r.kind == 'Comment' || r.kind == 'UserRequest') {
            return sender.image_url;
        }
        else {
            return r.data.image_url;
        }
    },

    getResource: function() {
        let r = this.get('resource');
        const p = this.get('parent_resources');

        if(r.kind == 'DataSet') {
            return _.find(p, function(r){
                return r.kind == 'Project';
            });
        }
        else if(r.kind == 'Comment'){
            return _.find(p, function(r){
                return r.kind == 'DataSet' || r.kind == 'Action';
            });
        }
        else if(r.kind == 'UserRequest'){
            r.data.name = r.data.title;
            return r;
        }
        else if(r.kind == 'UserRequestComment') {
            r.data.name = _.find(this.get('parent_resources'), r => {
                return r.kind == 'UserRequest'
            }).data.title;
            return r;
        }
        else {
            return r;
        }
    },

    getDetailMessages: function() {
        const d = [];
        const r = this.get('resource');
        const prefix = 'notification:' + this.get('event_type');

        if (r.kind == 'Task') {
            d.push({
                message: i18n.t(
                    prefix + '.summary', {task_name: r.data.name})
            });
        }
        if (r.kind == 'Action') {
            d.push({
                message: i18n.t(
                    prefix + '.summary')
            });
        }

        _.each(this.get('message'), function(msg) {
            if(!msg || !msg.body) {
                return
            }

            let m = Marked()(msg.body);
            const html = msg.markdown;
            m = $(m).text();
            d.push({
                message: m,
                html: html
            });
        });

        return d;
    }
});


// WEBPACK FOOTER //
// ./notify/domain/entity/notification.js